module.exports = __webpack_public_path__ + "img/banner.cddf413b.png";